<template>
  <v-container>
    <kim-background/>
    <v-row>
      <v-col cols="12">
        <h3>{{ $i18n.t('OverviewPage.welcome') }} {{participant.firstName}} {{participant.lastName}},</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <p v-html='$i18n.t("OverviewPage.welcomeSubtitle")'/>
        <p v-html='$i18n.t("OverviewPage.description")'/>
        <p>{{ $i18n.t('OverviewPage.entryLeave') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import LoadingState from '@/api/LoadingState';
import BusinessLogicOverview from '@/libs/businessLogicOverview';

import KimBackground from './KimBackground.vue';

export default {
  name: 'Overview',
  components: {
    KimBackground,
  },
  data: () => ({
    businessLogic: new BusinessLogicOverview(null),
  }),
  computed: {
    ...mapState({
      participant: (state) => state.run.participant,
      timetableLoaded: (state) => state.run.loadingState.timetable === LoadingState.LOADED
    }),
  },
  methods: {
    setExercise(exerciseId) {
      const logic = new BusinessLogicOverview(this);
      logic.setExercise(exerciseId);
    },
  },
  mounted() {
  },
};
</script>
